import { Type } from "@themes/pollinator/ui/Type";
import { MarketingSection } from "../../components/Section";

export function MarketingVision() {
  return (
    <MarketingSection
      title="We are building artist-led technology to weave relationships of mutual support."
      id="vision"
    >
      <Type variant="h4" className="max-w-3xl">
        Why this? Why now?
      </Type>
      <Type variant="body1" className="max-w-3xl">
        We believe that interdisciplinary practitioners across art, design,
        technology, and social impact have the desire and capacity to create
        opportunities for one another. Pollinator exists to build
        communities of solidarity across sectors, to make us all more
        resilient amidst crisis.
      </Type>
      <ul className="list-disc list-inside flex flex-col gap-6">
        <Type variant="body2" as="li" className="max-w-3xl">
          Relationships drive access to opportunity. While cohort programs
          like residencies and art schools elevate careers temporarily,
          aligned peer groups sustain us. Great people want to meet and
          support other great people, and by joining forces, we can go
          farther together.
        </Type>
        <Type variant="body2" as="li" className="max-w-3xl">
          It <span className="italic">is</span> possible to resist the
          endless scroll, and to instead create digital spaces of generative
          conflict and belonging. While the nature of content engagement has
          changed, our desire to form bonds in real time has not. The power
          of human-to-human intelligence is great, and our minds come alive
          in group settings.
        </Type>
        <Type variant="body2" as="li" className="max-w-3xl">
          Lastly, we believe that you, our participants, will guide and
          support us as we continue to build Pollinator. We are here to
          create infrastructure that is made by, for, and with artists, in
          service of mutual support, and we value your contributions to this
          project.
        </Type>
      </ul>
      <Type variant="h4" className="max-w-3xl">
        Your presence—being caring, curious, and open—is more transformative
        than your expertise.
      </Type>
    </MarketingSection>
  );
}

export default MarketingVision;
